import { render, staticRenderFns } from "./OverdueDeptorReport.vue?vue&type=template&id=456c7de4&"
import script from "./OverdueDeptorReport.vue?vue&type=script&lang=js&"
export * from "./OverdueDeptorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports